export default "__VITE_ASSET__0QjTTHMW__"